import React, { useEffect } from 'react';

/**
 * The ··· sheet. Design handoff §4 "··· sheet".
 *
 * On your own Portal it shows SEEN BY as a NUMBER and nothing else — never a list of who
 * watched. That is the product rule, in both directions: nobody finds out who was watching,
 * including the person who posted.
 *
 * The video holds and mutes while this is open; StoryViewer owns that.
 */
export default function StorySheet({ open, onClose, rows = [], seenCount = null, reduced = false }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') { e.stopPropagation(); onClose(); } };
    window.addEventListener('keydown', onKey, true);
    return () => window.removeEventListener('keydown', onKey, true);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="absolute inset-0 z-40 flex flex-col justify-end">
      <button
        type="button"
        aria-label="Close"
        onClick={onClose}
        className="absolute inset-0 cursor-default"
        style={{ background: 'rgba(0,0,0,0.60)' }}
      />
      <div
        role="menu"
        className="relative"
        style={{
          background: '#000000',
          borderTop: '2px solid #FFFFFF',
          animation: reduced ? 'none' : 'prSlabUp 200ms cubic-bezier(0,0,0.2,1)',
        }}
      >
        {seenCount != null && (
          <div style={{ padding: '16px 20px', borderBottom: '2px solid #1F1F1F' }}>
            <p className="font-mono font-bold uppercase" style={{ fontSize: 10, letterSpacing: '0.10em', color: 'rgba(255,255,255,0.60)' }}>
              Seen by
            </p>
            <p className="mt-1 font-mono font-bold text-white" style={{ fontSize: 20 }}>{seenCount}</p>
          </div>
        )}

        {rows.map((row) => (
          <button
            key={row.key}
            type="button"
            role="menuitem"
            onClick={row.onClick}
            className="pr-sheet-row w-full text-left font-mono font-bold uppercase"
            style={{
              borderBottom: '2px solid #1F1F1F',
              fontSize: 12,
              letterSpacing: '0.10em',
              color: row.destructive ? '#EF4444' : '#FFFFFF',
              padding: '16px 20px',
              transition: 'background-color 200ms',
            }}
          >
            {row.label}
          </button>
        ))}
      </div>
    </div>
  );
}
